import React from 'react';
import { PlayIcon } from '../../Basic/Icons/ButtonIcons/ButtonIcons.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import { StyledDurationTime, StyledDurationIcon } from './Duration.styles.mjs';
import { useTheme } from 'styled-components';

const Duration = ({ className, durationTime }) => {
    const theme = useTheme();
    return (React.createElement(FlexContainer, { className: className },
        React.createElement(StyledDurationTime, null, durationTime),
        React.createElement(StyledDurationIcon, null,
            React.createElement(PlayIcon, { color: theme.colors.white }))));
};

export { Duration as default };
//# sourceMappingURL=Duration.mjs.map
